import { translationsManager } from "./TranslationsManager.slice";

export const translationsManagerActions = { ...translationsManager.actions };
